import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import apiHelpers from '../../../utils/apiHelpers';

const SelectFunctionalTags = props => {
  const [tagOptions, setTagOptions] = useState([]);

  useEffect(() => {
    apiHelpers.getFunctionalTags().then(res => {
      const tags = res.data || [];
      setTagOptions(tags.map(tag => ({ value: tag.slug, label: tag.name })));
    });
  }, []);

  const onChangeWrapper = selectedOptions => {
    let event = { target: {} };
    event.target.name = props.name ? props.name : 'select-nameless';
    event.target.value = selectedOptions
      ? selectedOptions.map(option => option.value)
      : [];
    event.target.type = 'react-select-multi';
    props.onChange(event);
  };

  const value = Array.isArray(props.value)
    ? tagOptions.filter(option => props.value.includes(option.value))
    : [];

  return (
    <Select
      className={props.selectClassName}
      name={props.name}
      onChange={onChangeWrapper.bind(this)}
      value={value}
      required={props.required}
      options={tagOptions}
      isMulti={true}
      isClearable={false}
      placeholder={props.placeholder}
      menuPortalTarget={document.body}
      disabled={props.disabled}
      styles={{
        control: provided => ({
          ...provided,
          minHeight: '40px',
          padding: '0 0px',
          borderRadius: '0.375rem',
        }),
        dropdownIndicator: provided => ({
          ...provided,
          padding: '0 8px',
        }),
        clearIndicator: provided => ({
          ...provided,
          padding: '0 8px',
        }),
        input: provided => ({
          ...provided,
          padding: '0',
          margin: '0',
        }),
        multiValue: provided => ({
          ...provided,
          backgroundColor: '#e2e8f0',
          borderRadius: '0.25rem',
        }),
        multiValueLabel: provided => ({
          ...provided,
          color: '#1e293b',
        }),
        multiValueRemove: provided => ({
          ...provided,
          color: '#64748b',
          ':hover': {
            backgroundColor: '#cbd5e1',
            color: '#1e293b',
          },
        }),
      }}
    />
  );
};

export default SelectFunctionalTags;
